import * as ng from 'angular';
import {UISelectService} from '../../../../services/ui-select.service';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {IRivenditore} from '../../../../commons/interfaces/IRivenditore';
import {FileService} from '../../../../services/file.service';

class GestioneRivenditoriContoller implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    '$uibModal',
    'ArchiSmallServices',
    '$sce',
    '$filter',
    'UiSelectService',
    'FileService',
  ];

  constructor(
    private $scope: {
      rivenditori: IRivenditore[]
      [key: string]: any
    },
    private $rootScope: any,
    private $state: any,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: ng.ISCEService,
    private $filter: ng.IFilterService,
    private UISelectService: UISelectService,
    private fileService: FileService,
  ) {
    $scope.pageHeader = 'Gestione Rivenditori Archismall';
    $scope.pageSubHeader = '';
    $rootScope.formsubmitted = false;

    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };


    $scope.getRivenditori = () => {
      // logica per prendere dal database i profili
      ArchiSmallServices.getRivenditori().then((response) => {
        $scope.rivenditori = JSON.parse(JSON.stringify(response)) as IRivenditore[];
        $scope.rivenditori.sort((a, b) => a.name.localeCompare(b.name));
      }, (error) => {
        console.error(error);
      });
    };
    $scope.getRivenditori();

    $scope.exportCsv = () => {
      fileService.downloadCsv(ArchiSmallServices.getRivenditoriCsv());
    };

    $scope.refreshResults = ($select) => {
      UISelectService.refreshResults($select);
    };

    $scope.create = (size) => {

      let CreateModal = $uibModal.open({
        animation: true,
        component: 'createRivenditoreModalComponent',
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {}
      });
      CreateModal.result.then(res => {
        setTimeout($scope.getRivenditori, 500);
      });

    };

    $scope.edit = (item: IRivenditore) => {

      let EditModal = $uibModal.open({
        animation: true,
        component: 'editRivenditoreModalComponent',
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          rivenditore: () => {
            return item;
          }
        }
      });
      EditModal.result.then(res => {
        setTimeout($scope.getRivenditori, 500);
      });
    };

    $scope.delete = (item: IRivenditore) => {

      let DeleteModal = $uibModal.open({
        animation: true,
        component: 'deleteRivenditoreModalComponent',
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          rivenditore: () => {
            return item;
          }
        }
      });
      DeleteModal.result.then(res => {
        setTimeout($scope.getRivenditori, 500);
      });
    };

  }
}

export const GestioneRivenditoriComponent: ng.IComponentOptions = {
  template: require('./gestione-rivenditori.html'),
  controller: GestioneRivenditoriContoller
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/gestione-rivenditori/gestione-rivenditori.ts